import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const LMSCoursesBasicComponent = ({
    selectLMSCourses, handleInnerFormChange, TopicsList, libraryData, learningPathCategory
}: any) => {

    return (
        <AccordionContainer
            child={
                <div className='grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer
                        label="Title"
                        labelField="Title"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'Title');
                        }}
                        type="text"
                        value={selectLMSCourses?.Title}
                    />

                    <InputContainer
                        label="Author"
                        name="AuthorId"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'AuthorId');
                        }}
                        type="number"
                        value={selectLMSCourses?.AuthorId}
                    />

                    <InputContainer
                        label="published date"
                        name="PublishedDate"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'PublishedDate');
                        }}
                        type="date"
                        value={selectLMSCourses?.PublishedDate}
                    />

                    <InputContainer

                        label="Free Of Cost"
                        name="IsFreeOfCost"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event, 'IsFreeOfCost');
                        }}
                        type="checkbox"
                        value={selectLMSCourses?.IsFreeOfCost}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'Description');
                        }}
                        type="text"
                        value={selectLMSCourses?.Description}
                    />
                    <InputContainer
                        label="short description"
                        name="ShortDescription"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'ShortDescription');
                        }}
                        type="text"
                        value={selectLMSCourses?.ShortDescription}
                    />

                    <InputContainer
                        label="Duration"
                        name="Duration"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'Duration');
                        }}
                        type="text"
                        value={selectLMSCourses?.Duration}
                    />

                    <InputContainer
                        label="Difficulty Level"
                        labelField="Text"
                        list={libraryData}
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'DifficultyLevel');
                        }}
                        optionName="Choose Difficulty"
                        type="select"
                        value={selectLMSCourses?.DifficultyLevel}
                        valueField="Text"
                    />


                    <InputContainer
                        label="DisplayOrder"
                        name="DisplayOrder"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'DisplayOrder');
                        }}
                        type="number"
                        value={selectLMSCourses?.DisplayOrder}
                    />

                    <InputContainer
                        label="Price"
                        name="Price"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event.target.value, 'Price');
                        }}
                        type="number"
                        value={selectLMSCourses?.Price}
                    />


                    <InputContainer
                        label="Category"
                        labelField="Text"
                        list={learningPathCategory}
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Category'
                            );
                        }}
                        optionName="Choose Category"
                        type="select"
                        valueField="Text"
                        value={selectLMSCourses?.Category}
                    />

                    <InputContainer

                        label="Published"
                        name="IsPublished"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(event, 'IsPublished');
                        }}
                        type="checkbox"
                        value={selectLMSCourses?.IsPublished}
                    />

                    <div className='col-span-full'>
                        <InputContainer
                            label="Learning Out comes"
                            name="LearningOutcomes"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'LearningOutcomes'
                                )
                            }}
                            type="rte"
                            value={selectLMSCourses?.LearningOutcomes}
                        />
                    </div>

                    <div className='col-span-full'>
                        <InputContainer
                            label="Course Features"
                            name="CourseFeatures"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'CourseFeatures'
                                )
                            }}
                            type="rte"
                            value={selectLMSCourses?.CourseFeatures}
                        />
                    </div>
                    <div className='col-span-full'>
                        <InputContainer
                            label="Requirements"
                            name="Requirements"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'Requirements'
                                )
                            }}
                            type="rte"
                            value={selectLMSCourses?.Requirements}
                        />
                    </div>

                    <div className='col-span-full'>
                        <InputContainer
                            label="Course Includes"
                            name="CourseIncludes"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'CourseIncludes'
                                )
                            }}
                            type="rte"
                            value={selectLMSCourses?.CourseIncludes}
                        />
                    </div>






                </div>
            }
            expandedPanel="BasicInfo"
            headerTitle="Basic Info"
        />
    );
};

export default LMSCoursesBasicComponent;
